/**
 * Single source of truth for the API base URL.
 *
 * In every deployment mode the frontend and backend are served from the SAME
 * origin via the Kubernetes ingress (which routes `/api/*` to the FastAPI
 * backend). That means the cleanest, most robust base URL is simply the
 * browser's own `window.location.origin`.
 *
 * Why not just use `process.env.REACT_APP_BACKEND_URL`?
 * Emergent's deploy pipeline injects a build-time host (e.g. `*.emergent.host`)
 * into the bundle, but the user actually visits the site via a CUSTOM domain
 * (e.g. `www.vinepass.co.za`). The resulting cross-origin requests get blocked
 * by CORS / cookie rules. Using same-origin sidesteps this entirely.
 *
 * The env var is kept as a fallback for environments where `window` is not
 * available (e.g. SSR, tests).
 */
export const BACKEND_URL =
  typeof window !== 'undefined' && window.location && window.location.origin
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;

export default BACKEND_URL;
